// 因为插件是特殊独立页面，并且资源链接会动态变化，所以只能动态插入 JS CSS
// 插件页："/apps/order-tracking"
fetch("/apps/order-tracking")
  .then((res) => {
    return res.text();
  })
  .then((content) => {
    const tempEl = document.createElement("div");
    tempEl.innerHTML = content;
    const allCss = tempEl.querySelectorAll("link");
    const allJs = tempEl.querySelectorAll("script");
    for (const _css of allCss) {
      const src = _css.getAttribute("href");
      if (src && src.includes("apps.synctrack.io")) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = src;
        document.head.appendChild(link);
      }
    }
    for (const _js of allJs) {
      const src = _js.getAttribute("src");
      if (src && src.includes("apps.synctrack.io")) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = src;
        document.head.appendChild(script);
        // script.onload = onOrderTrackingAppLoaded();
      }
    }
  });

const onOrderTrackingAppLoaded = () => {
  const trackButtons = document.querySelectorAll(
    ".omg-section .omg-form .btn.btn-custom"
  );
  for (const btn of trackButtons) {
    btn.innerHTML = "Track Now";
  }

  const policyLinks = document.querySelector(".omg-footer-link .omg-policy");
  const TabContent1 = document.querySelector("tab-container");
  TabContent1.appendChild(policyLinks);

  document.querySelector("#input-order-name").placeholder =
    "Enter your order ID";
  document.querySelector("#input-email").placeholder = "Enter your order ID";
  document.querySelector("#input-tracking-number").placeholder =
    "Enter your tracking number";
};

(function () {
  window.addEventListener("load", onOrderTrackingAppLoaded);
})();

// 复制自插件页
function googleTranslateElementInit() {
  new google.translate.TranslateElement(
    { pageLanguage: "en" },
    "google_translate_element"
  );
}

setTimeout(() => {
  const e = document.querySelector(".goog-te-combo"),
    o = document.querySelector(".goog-te-banner-frame");
  e.addEventListener("change", () => {
    o.classList.add("gg-visible");
  });
}, 1e3);

!(function (e) {
  function r(r) {
    for (
      var n, u, i = r[0], c = r[1], l = r[2], s = 0, f = [];
      s < i.length;
      s++
    )
      (u = i[s]),
        Object.prototype.hasOwnProperty.call(o, u) && o[u] && f.push(o[u][0]),
        (o[u] = 0);
    for (n in c) Object.prototype.hasOwnProperty.call(c, n) && (e[n] = c[n]);
    for (p && p(r); f.length; ) f.shift()();
    return a.push.apply(a, l || []), t();
  }
  function t() {
    for (var e, r = 0; r < a.length; r++) {
      for (var t = a[r], n = !0, i = 1; i < t.length; i++) {
        var c = t[i];
        0 !== o[c] && (n = !1);
      }
      n && (a.splice(r--, 1), (e = u((u.s = t[0]))));
    }
    return e;
  }
  var n = {},
    o = { 1: 0 },
    a = [];
  function u(r) {
    if (n[r]) return n[r].exports;
    var t = (n[r] = { i: r, l: !1, exports: {} });
    return e[r].call(t.exports, t, t.exports, u), (t.l = !0), t.exports;
  }
  (u.e = function (e) {
    var r = [],
      t = o[e];
    if (0 !== t)
      if (t) r.push(t[2]);
      else {
        var n = new Promise(function (r, n) {
          t = o[e] = [r, n];
        });
        r.push((t[2] = n));
        var a,
          i = document.createElement("script");
        (i.charset = "utf-8"),
          (i.timeout = 120),
          u.nc && i.setAttribute("nonce", u.nc),
          (i.src = (function (e) {
            return (
              u.p +
              "static/js/" +
              ({}[e] || e) +
              "." +
              { 3: "6a348488" }[e] +
              ".chunk.js"
            );
          })(e));
        var c = new Error();
        a = function (r) {
          (i.onerror = i.onload = null), clearTimeout(l);
          var t = o[e];
          if (0 !== t) {
            if (t) {
              var n = r && ("load" === r.type ? "missing" : r.type),
                a = r && r.target && r.target.src;
              (c.message =
                "Loading chunk " + e + " failed.\n(" + n + ": " + a + ")"),
                (c.name = "ChunkLoadError"),
                (c.type = n),
                (c.request = a),
                t[1](c);
            }
            o[e] = void 0;
          }
        };
        var l = setTimeout(function () {
          a({ type: "timeout", target: i });
        }, 12e4);
        (i.onerror = i.onload = a), document.head.appendChild(i);
      }
    return Promise.all(r);
  }),
    (u.m = e),
    (u.c = n),
    (u.d = function (e, r, t) {
      u.o(e, r) || Object.defineProperty(e, r, { enumerable: !0, get: t });
    }),
    (u.r = function (e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (u.t = function (e, r) {
      if ((1 & r && (e = u(e)), 8 & r)) return e;
      if (4 & r && "object" == typeof e && e && e.__esModule) return e;
      var t = Object.create(null);
      if (
        (u.r(t),
        Object.defineProperty(t, "default", { enumerable: !0, value: e }),
        2 & r && "string" != typeof e)
      )
        for (var n in e)
          u.d(
            t,
            n,
            function (r) {
              return e[r];
            }.bind(null, n)
          );
      return t;
    }),
    (u.n = function (e) {
      var r =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return u.d(r, "a", r), r;
    }),
    (u.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }),
    (u.p = "https://apps.synctrack.io/tracking-page-order-tracking/build/"),
    (u.oe = function (e) {
      throw (console.error(e), e);
    });
  var i = (this.webpackJsonptracking_page =
      this.webpackJsonptracking_page || []),
    c = i.push.bind(i);
  (i.push = r), (i = i.slice());
  for (var l = 0; l < i.length; l++) r(i[l]);
  var p = c;
  t();
})([]);

!(function (t) {
  var e = function (e) {
    var n, a;
    ((n = t.createElement("script")).type = "text/javascript"),
      (n.async = !0),
      (n.src = e),
      (a = t.getElementsByTagName("script")[0]).parentNode.insertBefore(n, a);
  };
  setTimeout(function () {
    window.tdfInited ||
      ((window.altcdn = 1),
      e(
        "https://cdn.shopify.com/s/files/1/0013/1642/1703/t/1/assets/loader_2.js?shop=redragonshop.myshopify.com&v=42"
      ));
  }, 1689);
})(document);
